import { render, staticRenderFns } from "./NoteDetailView.vue?vue&type=template&id=a84b8542&scoped=true&"
import script from "./NoteDetailView.vue?vue&type=script&lang=js&"
export * from "./NoteDetailView.vue?vue&type=script&lang=js&"
import style0 from "./NoteDetailView.vue?vue&type=style&index=0&id=a84b8542&scoped=true&lang=scss&"
import style1 from "./NoteDetailView.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a84b8542",
  null
  
)

export default component.exports